<template>
  <div class="clock-info">
    <div v-if="is_bind == 1" class="container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="nickname" label="昵称" width="180"> </el-table-column>
        <el-table-column prop="avatar" label="头像" width="180">
          <img :src="scope.row.poster" class="avatar" alt="" slot-scope="scope" />
        </el-table-column>
        <el-table-column prop="clock_time" label="阅读时长" width="180"> </el-table-column>
        <el-table-column prop="clock_flag" label="打卡旗帜" width="180"> </el-table-column>
        <el-table-column prop="clock_day" label="打卡天数" width="180"> </el-table-column>
        <el-table-column prop="username" label="姓名" width="180"> </el-table-column>
        <el-table-column prop="phone" label="联系方式" width="180"> </el-table-column>
        <el-table-column prop="from" label="机构" width="180"> </el-table-column>
        <el-table-column prop="department" label="院系班级" width="180"> </el-table-column>
        <el-table-column prop="organize" label="社团" width="180"> </el-table-column>
        <el-table-column prop="group" label="组别" width="180"> </el-table-column>

      </el-table>
      <div class="row">
        <div class="row-end">
          <button @click="prevPage" class="prev btn">上一页</button>
          <button @click="nextPage" class="next btn">下一页</button>
          <button @click="exportExcel" class="export btn ">导出表格</button>
        </div>
      </div>
    </div>
    <div v-else class="msg-box">
      <p class="msg-text">请通过审核后，查看打卡活动信息！</p>
    </div>
  </div>
</template>

<script>
import { formToTime } from "@/utils/tools";
const avatar_url = require("../../../../assets/img/avatar_reset.png");
import store from "@/store/index.js";

export default {
  name: "clock-info",

  components: {},
  props: {},
  data() {
    return {
      storeData: store.state,

      tableData: [],
      // testimg: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
      peopleTotal: 0,
      rank_num: 0,
      currentPage: 1,
      hasNext: true,
    };
  },
  watch: {},
  computed: {
    is_bind() {
      if (this.storeData.adminInfo) {
        return this.storeData.adminInfo.is_bind;
      } else {
        return "";
      }
    },
  },
  methods: {
    // //   上一页
    // previousPage() {
    //   //
    // },
    //   下一页
    // nextPage() {
    //   //
    // },
    async getLibraryRankInfo() {
      try {
        const res = await this.$api.getLibraryRankInfo({
          params: {
            token: localStorage.getItem("admin-token"),
          },
        });
        this.rank_num = res.data.rank_num;
        this.peopleTotal = res.data.rank_info.num;
      } catch (error) {}
    },
    async getLibraryClockInfo() {
      try {
        const res = await this.$api.getLibraryClockInfo({
          params: {
            token: localStorage.getItem("admin-token"),
            page: this.currentPage,
          },
        });
        this.tableData = this.handleData(res.data.list);
        const total = 20 * (this.currentPage - 1) + res.data.list.length;
        this.hasNext = total < res.data.total_num ? true : false;
      } catch (error) {}
    },
    handleData(res) {
      res.forEach((item, index) => {
        // item.clock_time = 3800;
        // item.clock_time = formToTime(item.clock_time);
        item.poster = item.poster ? item.poster : avatar_url;
      });
      return res;
    },
    nextPage() {
      if (this.hasNext) {
        this.currentPage++;
        this.getLibraryClockInfo();
      } else {
        this.$message.closeAll();
        this.$message({
          message: "已是最后一页了",
          type: "warning",
          offset:300,
            duration:2000
        });
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getLibraryClockInfo();
      } else {
        this.$message.closeAll();
        this.$message({
          message: "已是第一页了",
          type: "warning",
          offset:300,
            duration:2000
        });
      }
    },
    async exportExcel() {
      // /match/works/export-clock
      try {
        // const url = '' ;
        const elink = document.createElement("a");
        elink.style.display = "none";
        // http://192.168.1.103/api/v1    https://www.yulin365.net/api/v1
        elink.href =
          "https://www.yulin365.net/api/v1/match/works/export-clock?token=" +
          localStorage.getItem("admin-token") +
          "&keywords=" +
          this.searchText +
          "&activity_id=" +
          this.activityId +
          "&status=" +
          this.status;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } catch (error) {
        console.error("err", error);
      }
    },
  },
  created() {

    // this.getLibraryRankInfo();
    this.getLibraryClockInfo();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.clock-info {
  margin: 40px 0;
  ::v-deep .has-gutter th {
    background-color: #f0eadd;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
    .labels {
      display: flex;
      border-radius: 5px;
      overflow: hidden;
      align-items: center;
      color: #999999;
      .label {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        height: 50px;
        padding: 0 20px;
        &:first-child {
          border-right: 1px solid #ddd;
        }
        .red {
          color: #815a4e;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
  }
  .row {
    padding-top: 30px;
    display: flex;
    justify-content: flex-end;
    .row-end {
      .btn {
        cursor: pointer;
        min-width: 100px;
        height: 40px;
        border-radius: 0;
        outline: none;
        border: 1px solid #999999;
        color: #815a4e;
        &:nth-child(1) {
          border-right: none;
        }
        &:nth-child(2) {
          border-right: none;
        }
        &.export {
          background-color: #815a4e;
          color: #fff;
        }
      }
    }
  }

  .msg-box {
    min-height: 50vh;
    .msg-text {
      color: #815a4e;
      font-size: 16px;
      margin-top: 40px;
    }
  }
}
</style>
